export const INTERVIEW_ROUND_TYPES = [
  { value: 'phone_screen', label: 'Phone Screen' },
  { value: 'technical', label: 'Technical' },
  { value: 'behavioral', label: 'Behavioral' },
  { value: 'panel', label: 'Panel' },
  { value: 'final', label: 'Final Round' },
  { value: 'take_home', label: 'Take Home' },
  { value: 'other', label: 'Other' },
] as const

export const INTERVIEW_ROUND_FORMATS = [
  { value: 'in_person', label: 'In-Person' },
  { value: 'video_call', label: 'Video Call' },
  { value: 'phone', label: 'Phone' },
  { value: 'other', label: 'Other' },
] as const

export type InterviewRoundType = typeof INTERVIEW_ROUND_TYPES[number]['value']
export type InterviewRoundFormat = typeof INTERVIEW_ROUND_FORMATS[number]['value']

export const INTERVIEW_ROUND_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  INTERVIEW_ROUND_TYPES.map((t) => [t.value, t.label])
)

export const INTERVIEW_ROUND_FORMAT_LABELS: Record<string, string> = Object.fromEntries(
  INTERVIEW_ROUND_FORMATS.map((f) => [f.value, f.label])
)
